import { useEffect, useRef } from 'react';

/**
 * 修復 PrimeReact 下拉選單、AutoComplete 等輸入法在選字時
 * Enter / ArrowDown 被錯誤觸發選項的問題。
 */
const usePrimeDropdownImeFix = () => {
  const patchedInputs = useRef(new Set());
  const lastCompositionTime = useRef(0);

  // 將這兩個處理函數提取到 useEffect 外部
  const handleCompositionEnd = () => {
    lastCompositionTime.current = Date.now();
  };

  const handleKeydown = (e) => {
    const isComposing = e.isComposing || e.keyCode === 229;
    const key = e.key;
    const justFinishedComposing = Date.now() - lastCompositionTime.current < 100;

    // 組字中 or 剛結束組字：阻止 Enter（避免誤關閉選單）
    if (isComposing || (justFinishedComposing && key === 'Enter')) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }

    // 組字中：阻止上下鍵跳選項
    if (isComposing && ['ArrowDown', 'ArrowUp'].includes(key)) {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  useEffect(() => {
    const selectorList = [
      '.p-dropdown-filter',
      '.p-autocomplete-input',
      '.p-multiselect-filter',
    ];

    const patchInput = (input) => {
      if (patchedInputs.current.has(input)) return;

      input.addEventListener('compositionend', handleCompositionEnd);
      input.addEventListener('keydown', handleKeydown);
      patchedInputs.current.add(input);
    };

    const patchAllInputs = () => {
      selectorList.forEach((selector) => {
        document.querySelectorAll(selector).forEach(patchInput);
      });
    };

    patchAllInputs(); // 初始化

    const observer = new MutationObserver(() => {
      patchAllInputs();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => {
      // 清理觀察器
      observer.disconnect();
      // 清除事件監聽器
      patchedInputs.current.forEach((input) => {
        input.removeEventListener('compositionend', handleCompositionEnd);
        input.removeEventListener('keydown', handleKeydown);
      });
      patchedInputs.current.clear();
    };
  }, []);

  return null;
};

export default usePrimeDropdownImeFix;
